import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import CalendarInput from "../../../components/input/CalendarInput";
//services
import { getExtract } from "../../../services/Wallet/getExtract";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";

const WalletExtract = () => {
  const form = useForm();
  const { state } = useLocation();
  const navigate = useNavigate();
  const hasNavigated = useRef(false);
//  console.log(state);
  const errors = form.formState.errors;

  const [extract, setExtract] = useState(null);
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "id", header: "Código" },
    { field: "parcel", header: "Parcela" },
    { field: "client", header: "Cliente" },
    { field: "date", header: "Data" },
    { field: "description", header: "Descrição" },
    { field: "status", header: "Status" },
    { field: "value", header: "Valor" },
    { field: "dataLiberacao", header: "Data Liberação" },
    { field: "saldo", header: "Saldo Após" },
  ];

  // useEffect(() => {
  //   if (state && state.token_lt) {
  //     const sendData = {
  //       token_lt: state.token_lt,
  //       inicio: new Date(),
  //       fim: new Date(),
  //     };
  //     const response = getExtract(sendData);
  //     const tableData = response.extrato.map(e => (
  //       {
  //         id: e.id_saldo,
  //         parcel: e.lt_idparcelas,
  //         client: e.lt_nome_cli,
  //         date: e.data_op,
  //         description: e.lt_descricao_empreendimento,
  //         status: statusName(e.status_op),
  //         value: formatCurrency(e.valor_op),
  //         dataLiberacao: e.saldo_data_liberacao,
  //         saldo: formatCurrency(e.saldo_apos),
  //       }
  //     ));
  //     setExtract(tableData);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const onSubmit = async (data) => {
//    console.log(data);
    const notification = toast.loading("Realizando o estorno de recebimento..");
    setLoading(true);
    const sendData = {
      token_lt: state.token_lt,
      start: data.dateFirst,
      end: data.dateEnd,
    };
    const response = await getExtract(sendData);
    // console.log(response);
    if(response.extrato) {
      const tableData = response.extrato.map((e) => ({
        id: e.id_saldo,
        parcel: e.lt_idparcelas,
        client: e.lt_nome_cli,
        date: e.data_op,
        description: e.descricao_op,
        status: statusName(e.status_op),
        value: formatCurrency(e.valor_op),
        dataLiberacao: e.saldo_data_liberacao,
        saldo: formatCurrency(e.saldo_apos),
      }));
      setExtract(tableData);
      setLoading(false);
  
      toast.update(notification, {
        render: "Busca realizada com sucesso!",
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } else {
      setLoading(false);
      toast.update(notification, {
        render: response.error.message,
        type: "warning",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  function statusName(id) {
    let name;
    switch (id) {
      case 0:
        name = "Processamento";
        break;
      case 1:
        name = "Efetivado";
        break;
      default:
        break;
    }
    return name;
  }

  const items = [
    {
      template: () => (
        <Link to={"/wallet/dashboard"} className="p-breadcrumb-link">
          Extrato
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/wallet/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  useEffect(() => {
    if (state === null && !hasNavigated.current) {
      hasNavigated.current = true;
      toast.warning("Houve um erro a buscar os dados, tente novamente");
      navigate("/wallet/dashboard");
    }
  }, [state, navigate]);

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <div className="row">
        <Panel>
          <h4>Extrato por Período</h4>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-4">
                <CalendarInput
                  name="dateFirst"
                  control={form.control}
                  errors={errors}
                  label={`Data Inicial`}
                />
              </div>
              <div className="col-md-4">
                <CalendarInput
                  name="dateEnd"
                  control={form.control}
                  errors={errors}
                  maxDate={new Date()}
                  label={`Data Final`}
                />
              </div>
              <div className="col-md-4 pt-3">
                <Button
                  rounded
                  type="submit"
                  iconPos="left"
                  label="Consultar"
                  icon="fa-solid fa-magnifying-glass"
                  className="p-inputtext-sm m-auto w-100"
                  loading={loading}
                />
              </div>
            </div>
          </form>
        </Panel>

        <Panel mainCss="mt-4">
          <h4>Extrato</h4>
          <DataTable
            rows={5}
            paginator
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            rowsPerPageOptions={[5, 25, 100]}
            value={extract}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            {columns.map((col) => (
              <Column
                sortable
                key={col.field}
                field={col.field}
                header={col.header}
              />
            ))}
          </DataTable>
        </Panel>
      </div>
    </>
  );
};

export default WalletExtract;
